<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="calibre_pb_0">HIDDEN TREASURES</h1>
<h1 class="calibre1 sigil_not_in_toc">OR WHY SOME SUCCEED WHILE</h1>
<h1 class="calibre1 sigil_not_in_toc">OTHERS FAIL<br class="calibre2"/></h1>
<h2 class="calibre1 sigil_not_in_toc">BY Harry A. Lewis</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?c1ac1cae